import { BondType } from '@/models/config'
import { BondTypesService } from '@/services/config'
import { ref, Ref, computed } from '@vue/composition-api'

export default function useBondType () {
  const bondTypes: Ref<BondType[]> = ref([])
  const loadingBondTypes: Ref<boolean> = ref(false)

  const getBondTypesActivated = async (name = '', code = '', is_massive: boolean | null = null) => {
    loadingBondTypes.value = true
    bondTypes.value = await BondTypesService.getActivated(name, code, is_massive)
    loadingBondTypes.value = false
  }
  getBondTypesActivated()

  const bondTypesOp = computed(() => {
    return bondTypes.value.map(type => {
      return {
        value: Number(type.id),
        text: type.name
      }
    })
  })

  return { bondTypes, bondTypesOp, getBondTypesActivated, loadingBondTypes }
}
